import { useState } from "react";
import { Input, Layout, Title } from "@introist/react-foundation/v2";
import { ToggleSettingCard } from "components/organisms";
import { getEventSettingsMetadata } from "../util";
import { useUpdateCompanyEventSetting } from "../hooks";
import { EventSettingProps } from ".";

export const MaxAttendees = ({ readOnly, setting }: EventSettingProps) => {
  const metadata = getEventSettingsMetadata(setting.setting);
  const [active, setActive] = useState(setting.active);
  // @ts-expect-error
  const [maxAttendees, setMaxAttendees] = useState(setting.conf.maxAttendees);
  const { updateEventSetting } = useUpdateCompanyEventSetting({
    setting,
    config: { enabled: !readOnly }
  });

  return (
    <ToggleSettingCard
      autoCollapse
      readOnly={readOnly}
      key={setting.setting}
      title={metadata.title}
      description={metadata.description}
      active={active}
      onToggleActive={active => {
        setActive(active);
        updateEventSetting({ active }, () => setActive(setting.active));
      }}
    >
      <Layout.Group>
        <Input
          type="number"
          value={maxAttendees}
          min={0}
          size="small"
          style={{ maxWidth: 48 }}
          onChange={value => {
            setMaxAttendees(Number(value));
            updateEventSetting({ conf: { maxAttendees: Number(value) } }, () =>
              // @ts-expect-error
              setMaxAttendees(setting.conf.maxAttendees)
            );
          }}
        />
        <Title>attendees maximum</Title>
      </Layout.Group>
    </ToggleSettingCard>
  );
};
